export default {
    data() {
        return {
            //markdown配置tabbar
            markdownOption: {
                bold: true, // 粗体
                italic: true, // 斜体
                header: true, // 标题
                underline: true, // 下划线
                strikethrough: true, // 中划线
                mark: true, // 标记
                superscript: true, // 上角标
                subscript: true, // 下角标
                quote: true, // 引用
                ol: true, // 有序列表
                ul: true, // 无序列表
                link: true, // 链接
                // imagelink: true, // 图片链接
                code: true, // code
                table: true, // 表格
                fullscreen: true, // 全屏编辑
                readmodel: true, // 沉浸式阅读
                htmlcode: true, // 展示html源码
                help: true, // 帮助
                /* 1.3.5 */
                undo: true, // 上一步
                redo: true, // 下一步
                trash: true, // 清空
                save: true, // 保存（触发events中的save事件）
                /* 1.4.2 */
                navigation: true, // 导航目录
                /* 2.1.8 */
                // alignleft: true, // 左对齐
                // aligncenter: true, // 居中
                // alignright: true, // 右对齐
                /* 2.2.1 */
                subfield: true, // 单双栏模式
                preview: true, // 预览
            },

            // 富文本编辑器的配置
            // editor: null,
            // html: '<p>hello</p>',
            // toolbarConfig: {},
            // editorConfig: { placeholder: '请输入内容...' },
            // mode: 'default', // or 'simple'


            txt: '', //文本内容
            dialogShow: false,
            params: {
                title: '',
                blogDesc: '',
                content: '', //解析后的文本
                author: '',
                parent: [],
                type: '1',
                authorEmail: '',
                label: '',
            },
            labelList: [],//分类标签
            parent: [],//临时参数
            isOther: false,//其他的分类用于手动输入、
            term: "",//手动输入的分类
            maxChecked: 3,//最大可选
        }
    },
    created() {
        this.initLabel();
    },
    mounted() {
    },
    watch: {
        parent: { //给分类标签赋值
            handler(val) {
                //当超过三个分类时禁止选择
                if (val.length == 3) {
                    document.querySelectorAll("input[type='checkbox'][name='term']").forEach((item) => {
                        if (!val.includes(+item.value)) {
                            item.setAttribute("disabled", true)
                        }
                    })
                    document.querySelector("input[name='other']").setAttribute("disabled", true)
                    return;
                }

                document.querySelectorAll("input[type='checkbox']").forEach((item) => {
                    item.removeAttribute("disabled");
                })
            },
        }
    },
    methods: {
        //初始化分类
        async initLabel() {
            const { API, $request } = this;
            const url = API.getLabel;
            const { data: res } = await $request(url, 'get');
            this.labelList = res.data || [];
        },

        //提交分类
        async addTerm() {
            const { API, $request, term, labelList } = this;
            for (let item of labelList) {
                if (item.name.toLowerCase() === term.toLowerCase()) {
                    return alert("该分类已存在!");
                }
            }
            const url = API.addTerm;
            const { data: res } = await $request(url, 'post', {
                name: term
            });
            if (res.code == 200) {
                alert("新增分类成功!")
                this.term = "";
                this.isOther = false;
                this.initLabel();
                return;
            }
            alert(res.msg);
        },

        // onCreated(editor) {
        //     this.editor = Object.seal(editor) // 一定要用 Object.seal() ，否则会报错
        // },

        // 确认投稿
        async submit() {
            const { API, $request, params, parent, $utils } = this;

            if (!params.author) return alert("昵称不能为空!");
            if (!params.authorEmail) return alert("邮箱不能为空!");
            if (!$utils.isEmail(params.authorEmail)) return alert("邮箱格式错误!");

            if (params.type == '0') {
                if (!params.title) return alert("随笔标题不能为空!");
                if (!params.blogDesc) return alert("随笔标题不能为空!");
                if (!parent.length) return alert("随笔分类不能为空!");
                const ungenerated = this.$refs['tagSelect'].ungenerated();//判断是否有未生成的标签
                if (ungenerated) {
                    return alert("存在未生成的标签");
                }
            }



            params.parent = parent.join(",");
            const url = API.contribute;

            const { data: res } = await $request(url, 'post', params);
            if (res.code == 200) {
                this.txt = "";
                alert("感谢投递,管理员正在快马加鞭审核!");
                return this.hide(1);
            }
            alert(res.msg);
        },

        //获取标签
        getTag(val) {
            this.params.label = val.join(",");
        },

        //展示弹框
        showDialog() {
            if (!this.params.content) return alert("投稿内容不能为空!");
            this.dialogShow = true;
        },


        //隐藏弹框
        hide(type) {
            this.dialogShow = false;
            let content = this.params.content;
            this.params = {
                title: '',
                blogDesc: '',
                author: '',
                content: '',//解析后的文本
                parent: [],
                type: '1',
            };
            if (type !== '1') this.params.content = content;
            this.term = "";
            this.parent = [];
            this.isOther = false;
        },

        //转换文本
        changeTxt(val, render) {
            this.params.content = render;
        }
    }
}